import styled from 'styled-components'

import { device } from '@/common/constants/device'

export default styled.main`
  max-width: ${(props) => `${props.isCentered ? '1664px' : `100%`}`};
  margin: ${(props) => `${props.isAutoMargin ? '0 auto' : `0`}`};
  padding: ${(props) => `${props.isPaddingNone ? 0 : `96px 8px 0`}`};
  width: ${(props) => `${props.isContainerFullWidth ? '100%' : ''}`};

  @media ${device.tablet} {
    padding: ${(props) => `${props.isPaddingNone ? 0 : `96px 20px 0`}`};
  }
  /* 
  @media ${device.laptop} {
    padding: ${(props) => `${props.isPaddingNone ? 0 : `96px 20px 0`}`};
  }

  @media ${device.laptopL} {
    padding: ${(props) => `${props.isPaddingNone ? 0 : `96px 12px 0`}`};
  } */
`
